export default "__VITE_ASSET__a21ea77f__"